import apiUrl from '../../../constants'
import axios from 'axios'
import AutoBagOutConfiguration from './AutoBagOutConfiguration/index.vue';
import Audit from './Audit/index.vue';


export default {
  name: 'AutoHandover',
  components: {
    'first': AutoBagOutConfiguration,
    'second': Audit
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Configuration'
        },
        {
          key: 'Second',
          value: 'Audit'
        }
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoBagOutConfiguration_v1/AutoBagOutConfiguration_v1.js